<template>
    <component
        :aria-label="iconAriaLabel"
        :is="componentType"
        :class="[$style['mds-button'], classObject, variationClass, sizeClass]"
        :href="href"
        v-on="$listeners"
        :data-mds-version="version"
    >
        <mds-icon
            v-if="icon"
            :class="[$style['mds-button__icon'], $style['mds-button__icon--left']]"
            :name="icon"
            :size="iconSize"
        ></mds-icon>
        <span v-if="variation !== 'icon-only'">
            <slot>{{ text }}</slot>
        </span>
        <mds-icon
            v-if="iconRight"
            :class="[$style['mds-button__icon'], $style['mds-button__icon--right']]"
            :name="iconRight"
            :size="iconSize"
        ></mds-icon>
        <transition name="mds-button__loader">
            <mds-loader
                v-if="loading && variation === 'primary'"
                :class="[$style['mds-button__loader']]"
                :aria-valuetext="loaderAriaValuetext"
                on-dark
            />
        </transition>
    </component>
</template>

<script>
    import MdsIcon from '@mds/icon';
    import MdsLoader from '@mds/loader';

    // Import component's API
    import MdsButtonProps from './button_props.js';

    export default {
        name: 'MdsButton',
        components: {
            MdsIcon,
            MdsLoader,
        },
        props: MdsButtonProps,
        computed: {
            componentType() {
                return this.href ? 'a' : 'button';
            },
            sizeClass() {
                return this.$style[`mds-button--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-component--on-dark']] = this.onDark;
                obj[this.$style['mds-button--flat-m-icon']] = this.mediumIcon;
                obj[this.$style['mds-button--loading']] = this.loading && this.variation === 'primary';

                return obj;
            },
            iconSize() {
                const isSmall =
                    this.size === 'small' ||
                    (this.size === 'medium' &&
                        this.variation !== 'icon-only' &&
                        this.flatButtonIconSize !== 'medium') ||
                    this.flatButtonIconSize === 'small';
                return isSmall ? 'small' : 'medium';
            },
            variationClass() {
                return this.$style[`mds-button--${this.variation}`];
            },
            iconAriaLabel() {
                let buttonText = this.text;
                if (this.$slots.default) {
                    buttonText = this.$slots.default[0].text;
                }
                return this.variation === 'icon-only' ? buttonText : null;
            },
        },
        data() {
            return {
                mediumIcon: false,
            };
        },
        mounted() {
            this.mediumIcon = this.iconSize === 'medium' && this.variation === 'flat' && this.size === 'medium';
        },
    };
</script>

<style lang="scss" module>
    @import './button.scss';
</style>
